import { render, staticRenderFns } from "./BriefButlerOverview.vue?vue&type=template&id=44f1133c"
import script from "./BriefButlerOverview.vue?vue&type=script&lang=js"
export * from "./BriefButlerOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports